import { useEffect, useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import { useModal } from "../../../contexts/ModalContext";
import useApi from "../../../hooks/useApi";

const ModalEditarTipo = ({ tipo, updateTipos, updateCategorias }) => {
    const api = useApi();
    const { closeModal } = useModal();

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [classificacoes, setClassificacoes] = useState([]);
    const [formValues, setFormValues] = useState({
        tipoRisco: tipo?.tipo ?? "",
        classificacao: tipo?.classificacao ?? "",
    });

    useEffect(() => {
        const fetchClassificacoes = async () => {
            setLoading(true);

            try {
                const { data } = await api.get("/Painel/API/Desvios/Classificacoes/");
                setClassificacoes(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error(error);
                setClassificacoes([]);
            } finally {
                setLoading(false);
            }
        };

        fetchClassificacoes();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setSaving(true);

        try {
            const formData = new FormData();
            formData.append("uuid", tipo.uuid);
            formData.append("tipoRisco", formValues.tipoRisco);
            formData.append("classificacao", formValues.classificacao);

            await api.post("/Painel/API/Desvios/UpdateTipoRisco/", formData);

            await updateTipos();
            await updateCategorias();
            closeModal();
        } catch (error) {
            console.log(error);
        } finally {
            setSaving(false);
        }
    };

    const optionsClassificacao = classificacoes.map((item) => ({
        value: item.id,
        label: item.nome,
    }));

    return (
        <Overlay state={true}>
            <Modal header close={closeModal}>
                {loading ? (
                    <SmallLoading />
                ) : (
                    <Formulario onSubmit={handleSubmit}>
                        <FormComp
                            title="TIPO DE RISCO"
                            type="text"
                            placeholder="DIGITE..."
                            name="tipoRisco"
                            changeFunc={(e) =>
                                setFormValues((prev) => ({
                                    ...prev,
                                    tipoRisco: e.target.value.toUpperCase(),
                                }))
                            }
                            valor={formValues.tipoRisco}
                            required
                        />
                        <FormComp
                            title="CLASSIFICAÇÃO"
                            type="select"
                            options={optionsClassificacao}
                            obj
                            name="classificacao"
                            changeFunc={(e) =>
                                setFormValues((prev) => ({
                                    ...prev,
                                    classificacao: e.target.value,
                                }))
                            }
                            valor={formValues.classificacao}
                            required
                        />
                        <FormComp valor={saving ? "SALVANDO…" : "SALVAR"} type="submit" />
                    </Formulario>
                )}
            </Modal>
        </Overlay>
    );
};

export default ModalEditarTipo;
